import React, { useEffect, useState } from "react";
import AddButtonSection from '../../components/common/AddButtonSection';
import { useForm } from "react-hook-form";
import InputIterator from '../../components/common/inputIterator';
import { passwordFormRender as formRender } from "../../utils/serviceData";
import { commonPostApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";

const Password = () => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    setError,
    watch,
    reset,
    clearErrors
  } = useForm();
  const [loader, setLoader] = useState(false);
  const [isDisable, setIsDisabled] = useState(true);

  useEffect(() => {
    const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
    const newPassword = watch("new_password");
    const oldPassword = watch("old_password");
    const confirmPassword = watch("confirm_password");

    if (newPassword && !regex.test(newPassword)) {
      setError("new_password", { message: "New password must follow the format below" });
    } else if (newPassword && newPassword === oldPassword) {
      setError("new_password", { message: "Current password and new password can't be the same" });
    } else {
      clearErrors("new_password");
    }

    if (confirmPassword && confirmPassword !== newPassword) {
      setError("confirm_password", { message: "Confirm password must match the new password" });
    } else {
      clearErrors("confirm_password");
    }

    const isValidNewPassword = regex.test(newPassword) && newPassword !== oldPassword;
    const isValidConfirmPassword = confirmPassword === newPassword;
    setIsDisabled(!(isValidNewPassword && isValidConfirmPassword))

  }, [watch("new_password"), watch("confirm_password"), watch("old_password")]);

  const onPasswordChange = async (data) => {
    if (loader) return;
    setLoader(true);
    await commonPostApi(
      API_ENDPOINTS.CHANGE_PASSWORD,
      { ...data },
    )
      .then((data) => {
        if (data?.data?.sucess) {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.AUTH.PASSWORD_CHANGED);
          reset({ old_password: "", new_password: "", confirm_password: "" });
        }
        else if (data?.response?.data === "Wrong password !") {
          showToast(TOAST_TYPE.ERROR, FEATURE_MSG.AUTH.WRONG_PASSWORD);
        }
        else {
          showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        }
        setLoader(false);
      })
  };
  var button = [
    {
      type: "primarySuccessButton",
      label: "Save Changes",
      class: "w-10rem md:w-11rem pr-3",
      onClick: handleSubmit(onPasswordChange),
    },
    {
      type: "secondaryButton",
      label: "Discard",
      class: "w-6rem md:w-7rem",
      onClick: () => {
        reset({
          old_password: "",
          new_password: "",
          confirm_password: ""
        });
      }
    },
  ];

  return (
    <>
      <div className="Password">
        <h4 className="Password__secondary mt-0">Change Password</h4>
        <div className="Password__form">
          <InputIterator
            control={control}
            errors={errors}
            formRender={formRender}
          />
        </div>
        <h5 className="Password__primary mb-4">Password Requirements: </h5>
        <ul>
          <li className="Password__primary text-sm font-normal mb-4">Minimum 8 characters long - the more, the better</li>
          <li className="Password__primary text-sm font-normal mb-4">At least one uppercase character</li>
          <li className="Password__primary text-sm font-normal mb-4">At least one number and special-character</li>
        </ul>
        <div className="pt-3 pl-2">
          <AddButtonSection disabled={isDisable} buttons={button} />
        </div>
      </div>

    </>
  );
};

export default Password;
